import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    // Steal focus if there is none already set
    if (document.activeElement.tagName === 'BODY') {
      const el = this.element;
      if (el.tagName === 'INPUT') {
        const end = el.value.length;
        el.setSelectionRange(end, end);
      }
      el.focus();
    }
  }
}
